import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { profileRoleService } from '../services/users/profileRoleService';
import { hasDeveloperAccess } from '../utils/profileRoles';

export function useProfileRoles() {
  const { user } = useAuth();

  const query = useQuery({
    queryKey: ['profile-roles', user?.id],
    queryFn: () => profileRoleService.getProfileRoles(user!.id),
    enabled: Boolean(user?.id),
    staleTime: 60_000,
  });

  return {
    ...query,
    roles: query.data ?? [],
    isDeveloper: hasDeveloperAccess(query.data),
  };
}
